import React, { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import './paymentSubscription.css';
import { Loader } from "@progress/kendo-react-indicators";

const PaymentSubscription = () => {
  const [selectedPlans, setSelectedPlans] = useState([]);
  const [plans, setPlans] = useState([]);
  const [businessId, setBussinessId] = useState(null);
  const [businessPhone, setBussinessPhone] = useState("");
  const [businessEmail, setBussinessEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    let _companySession = localStorage.getItem("vs_UserSession");
    if (_companySession != undefined || _companySession != null) {
      _companySession = JSON.parse(_companySession);
      
      let businessId = _companySession.loginId;
      let loginNumber = _companySession.loginNumber;
      let loginEmail = _companySession.loginEmail;

      setBussinessId(businessId);
      setBussinessPhone(loginNumber);
      setBussinessEmail(loginEmail);

      console.log('baseURL:', global.webUrl);

    }
  }, []);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const res = await fetch(`${global.API_STRIPEAPI_URL}getAllPlans?businessId=${businessId}`);
        const data = await res.json();
        setPlans(data.plans || []);
        const allPlans = data.plans || [];
        const filteredPlans = allPlans;
        
        setSelectedPlans(filteredPlans);
        
        
      } catch (err) {
        console.error("Error fetching plans:", err);
      }
    };
    if(businessId){
        fetchPlans();
    }

  }, [businessId]);




  const handleBuy = async (plan) => {
    const requestData = {
      businessId: businessId,
      businessPhone: businessPhone,
      businessEmail: businessEmail,
      priceId: plan.stripe_price_id,
      currency: plan.currency,
      setupAmount: plan.setup_amount * 100,
      baseURL: global.webUrl
    };
    setIsLoading(true);
    const response = await fetch(`${global.API_STRIPEAPI_URL}subscription`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
        // Backend returned an HTTP error (e.g. 400, 500)
        const errorData = await response.json();
        console.error("Subscription API error:", errorData);
        alert(errorData.message || "Failed to create subscription");
        return;
      }

      const session = await response.json();
      setIsLoading(false);
      // Redirect to the Stripe checkout page
      if (session && session.url) {
        window.location.href = session.url;
      } else {
        console.error("Invalid session response:", session);
        alert("Unable to start subscription. Please try again.");
      }
  };

  return (
    <div className="payment-section">
  <div className="payment-header">
    <h2>Plans & Pricing</h2>
    <p>Choose a plan that suits your business</p>
  </div>

    {
      selectedPlans.length === 0 && (
        // <p>No plans available at the moment. Please check back later.</p>
        <div className="country-warning">
          <h2>🌍 Not available in your country</h2>
          <p>No plans available at the moment. Please check back later.</p>
          <button className="waitlist-btn" onClick={() => {
            window.location.href =
              global.webUrl + "contact/";
          }}>Contact Us</button>
        </div>
      )
    }
  <div className="payment-grid">
   
    {selectedPlans.map((plan, index) => (
      <div
        key={index}
        className={`payment-card ${index % 2 === 0 ? "even" : "odd"}`}
      >
        <h3 className="plan-title">{plan.productName}</h3>
        <p className="plan-interval">
          {plan.interval_type.charAt(0).toUpperCase() + plan.interval_type.slice(1)} | Web + Mobile
        </p>

        <p className="plan-price">
          {plan.currency.toUpperCase()} {plan.amount}{" "}
          <span className="old-price">{(plan.amount * 1.06).toFixed(2)}</span>{" "}
          / {plan.interval_type.charAt(0).toUpperCase() + plan.interval_type.slice(1)}
        </p>
        <p className="setup-fee">
          {plan.currency.toUpperCase()} {plan.setup_amount}{" "}
          <span className="setup-text">one-time setup fee</span>
        </p>

        <ul className="feature-list">
          {plan.features.map((feature, featureIndex) => (
            <li key={featureIndex} className="feature-item">
              <span
                className={`feature-icon ${feature.is_available ? "available" : "unavailable"}`}
              >
                {feature.is_available ? "✔" : "✘"}
              </span>
              {feature.name}
            </li>
          ))}
        </ul>

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
          className="buy-button"
          themeColor={index % 2 === 0 ? "light" : "primary"}
          onClick={() => handleBuy(plan)}
        >
          Buy {plan.productName}
        </Button>
        </div>
      </div>
    ))}
  </div>
  {
    isLoading && (
      <Dialog >
        <Loader type="converging-spinner" />
      </Dialog>
    )
  }
</div>
  );
};

export default PaymentSubscription;